import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "me-1" };
const _hoisted_2 = { class: "me-1" };
const _hoisted_3 = { class: "me-1" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_cms_block = _resolveComponent("g-cms-block");
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        title: "Dokument bearbeiten",
        "class-content": "content d-flex flex-column flex-grow-1"
    }, {
        "modal-footer": _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.onSave()), ["prevent"]))
                }, " Speichern ")
            ]),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                    class: "btn btn-outline-secondary",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.onCancel()), ["prevent"]))
                }, " Abbrechen ")
            ]),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                    class: "btn btn-secondary",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.onTools()), ["prevent"]))
                }, [
                    _createVNode(_component_g_icon, { src: "/assets/icons/gear-wide-connected.svg" })
                ])
            ])
        ]),
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.slots, (slot) => {
                return (_openBlock(), _createBlock(_component_g_cms_block, { content: slot }, null, 8, ["content"]));
            }), 256))
        ]),
        _: 1
    }));
}
